<template>
    <div class="select-online">
        <div class="searching">
          <input v-model="query" class="form-control" type="text" placeholder="Wyszukaj użytkownika">
        </div>
        <table class="table">
            <tr v-for="client in filteredClients" :key="client.id">
                <td ><label :for="`check-` + client.id" class="clickable"> <client :client="client"/> </label></td>
                <td>
                    <input v-if="onlyOne" type="radio" class="clickable" :value="client.id" :id="`check-` + client.id" v-model="radio" :disabled="isOmitted(client)"/>
                    <input v-else type="checkbox" class="clickable" :value="client.id" :id="`check-` + client.id" v-model="selected" :disabled="isOmitted(client)"/>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "SelectOnline",
        props: {
            clients: Array,
            allChecked: Boolean,
            onlyOne:  Boolean,
            idType: String,
            omitted: Array,
        },
        data() {
            return {
                selected: [],
                radio: '',
                query: ''
            };
        },
        mounted() {
            this.clients.map(client => {
                client.id = client[this.idType];
            });

            if (this.allChecked && !this.onlyOne)
                for (let client of this.clients)
                    this.selected.push(client.id);

            this.$forceUpdate();
        },
        methods: {
            getResults() {
                return this.onlyOne ? this.radio : this.selected;
            },
            isOmitted(client) {
                if (this.omitted)
                    for (let om of this.omitted)
                        if (om.dbid == client.dbid)
                            return true;

                return false;
            }
        },
        computed: {
          filteredClients() {
            return this.clients.filter(client => {
              return client.nick.toLowerCase().includes(this.query.toLowerCase())
            })
          }
        }
    }
</script>

<style scoped>
    .clickable {
        cursor: pointer;
    }
</style>